var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMarkReview = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 21,
  height: 23,
  fill: "none",
  viewBox: "0 0 21 23"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M8.672.91a2.73 2.73 0 0 0-2.73 2.73v4.549h1.82v-4.55a.91.91 0 0 1 .91-.91h6.525a.9.9 0 0 1 .643.267l2.574 2.574a.9.9 0 0 1 .266.643v8.345a.91.91 0 0 1-.91.91h-3.639v1.82h3.64a2.73 2.73 0 0 0 2.729-2.73V6.213a2.73 2.73 0 0 0-.8-1.93L17.128 1.71a2.73 2.73 0 0 0-1.93-.8z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M9.582 4.55h5.459v1.82H9.58zM16.86 8.189v1.82h-1.99l-1.649-1.82z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M13.194 9.586a4.55 4.55 0 1 0-6.433 6.434 4.55 4.55 0 0 0 6.433-6.434m-5.146 1.287a2.73 2.73 0 1 1 3.86 3.86 2.73 2.73 0 0 1-3.86-3.86",
  clipRule: "evenodd"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m3.374 21.66 3.387-4.353-1.287-1.287-4.354 3.386a1.606 1.606 0 1 0 2.254 2.254"
})));
export default SvgMarkReview;